import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state: {
    auth: {
      authorized: false
    },
    meta: null,
    drawer: false,
    messages: {
      type: 'info',
      message: null,
      timeout: null,
      show: false,
      color: null,
      showCloseButton: false
    },
    page: {
      key: null,
      icon: null,
      color: null,
      alignment: null,
      plainTemplate: null,
      noImageFooter: null
    },
    browserInfo: null,
    webrpt: {
      state: null
    },
    configuration: null,
    breadcrumb: [],
    settings: {
      sorting: true,
      filterOpen: false,
      devices: 'all',
      deviceType: 'all',
      keywords: [],
      dateFormat: 'DD.MM.YYYY',
      timeFormat: 'HH:mm:ss',
      dateTimeFormat: 'DD.MM.YYYY HH:mm:ss',
      menutype: false,
      Energy: 'WattHours',
      Language: 'de',
      Power: 'Watts',
      Pressure: 'Bars',
      Temperature: 'DegreesCelsius',
      Volume: 'LitersPerHour'
    },
    lng: 'de',
    user: null,
    errorLogs: [],
    showAdminElements: false
  },
  getters: {
    storeAdminElements (state) {
      return state.showAdminElements
    },
    storeAuth (state) {
      const auth = {
        authorized: state.auth.authorized
      }
      return auth
    },
    storeUser (state) {
      return state.user
    },
    storeBrowserInfo (state) {
      return state.browserInfo
    },
    storeLng (state) {
      return state.lng
    },
    storeMeta (state) {
      return state.meta
    },
    storeMessages (state) {
      return state.messages
    },
    webRPT (state) {
      return state.webrpt
    },
    storePage (state) {
      const page = {
        key: state.page.key,
        icon: state.page.icon,
        color: state.page.color,
        alignment: state.page.alignment,
        plainTemplate: state.page.plainTemplate,
        noImageFooter: state.page.noImageFooter
      }
      return page
    },
    storeBreadcrumb (state) {
      return state.breadcrumb
    },
    storeSettings (state) {
      return state.settings
    },
    storeErrorLogs (state) {
      return state.errorLogs
    },
    storeDrawer (state) {
      return state.drawer
    },
    storeConfiguration (state) {
      return state.configuration
    }
  },
  mutations: {
    setNewMessages (state, payload) {
      this.state.user.newMessages = payload
    },
    setValidOwnershipCount (state, payload) {
      this.state.user.hasDemoOwnership = payload
      if (payload) {
        this.state.user.valid_ownership_count = this.state.user.valid_ownership_count++
      } else {
        this.state.user.valid_ownership_count = this.state.user.valid_ownership_count--
      }
    },
    setShortMenu (state, payload) {
      this.state.settings.short_menu = payload
    },
    setAuthorization (state, payload) {
      this.state.auth.authorized = payload || false
    },
    setUser (state, payload) {
      this.state.user = payload || null
    },
    setConfiguration (state, payload) {
      this.state.configuration = payload || null
    },
    setEulaVersion (state, payload) {
      this.state.user.eula_version = payload
    },
    toggleAdminElements (state, payload) {
      this.state.showAdminElements = !this.state.showAdminElements
    },
    setLng (state, lng) {
      this.state.lng = lng
    },
    setPage (state, page) {
      this.state.page = page
    },
    setBrowserInfo (state, payload) {
      this.state.browserInfo = payload
    },
    setWebRptState (state, payload) {
      this.state.webrpt.state = payload
    },
    showMessage (state, status) {
      this.state.messages = status
    },
    setMeta (state, meta) {
      this.state.meta = meta
    },
    setBreadcrumb (state, breadcrumb) {
      this.state.breadcrumb = breadcrumb
    },
    setSettings (state, obj) {
      for (const [key, val] of Object.entries(obj)) {
        this.state.settings[key] = val
      }
    },
    setErrorLogs (state, payload) {
      this.state.errorLogs = payload
    },
    setDrawer (state, payload) {
      this.state.drawer = payload
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store.js